import React from 'react'
import Map from './Map'
import ContactFormContainer from '../containers/ContactFormContainer'
import TrapezoidShape from './TrapezoidShape'
import { withNamespaces } from 'react-i18next'

export const Contacts = props => {
	const { t } = props
	return <div className='u-bg--black u-relative'>
		<TrapezoidShape className='u-show-on-desktop' position='right' size='large' direction='top' theme='light'/>
		<Map
			className='c-map--home'
			isMarkerShown
			googleMapURL='https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places'
			loadingElement={<div style={{ height: '100%' }} />}
			containerElement={<div className='c-map' />}
			mapElement={<div style={{ height: '100%' }} />}
		/>
		<div className='o-wrapper'>
			<div className='o-layout u-padding-vertical u-padding-vertical-huge@desktop'>
				<div className='o-layout__item u-1/1 u-1/2@tablet'>
				</div>
				<div className='o-layout__item u-1/1 u-1/2@tablet u-relative'>
					<h2 className='u-text--large u-text--white u-text--center u-margin-top@desktop'>{t('contactForm.title')}</h2>
					<ContactFormContainer isHome/>
				</div>
			</div>
		</div>
	</div>
}

export default withNamespaces()(Contacts)



// WEBPACK FOOTER //
// ./src/components/Contacts.js